import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { ButtonsComponent } from 'src/app/shared/components/buttons/buttons.component';
import { MatMenuModule } from '@angular/material/menu';
import { BankAccountTableRowDto } from '../../models/externalClientBankAccountDto.model';
import { EditAccountDetailsDialogComponent, EditAccountDetailsDialogContext } from '../edit-account-details-dialog/edit-account-details-dialog.component';
import { filter, switchMap, take, tap } from 'rxjs';
import { BankAccountsMsService } from '../../bank-accounts-ms.service';
import AccountType from 'src/app/shared/enums/AccountType.enum';
import { BankAccountProvider } from '../../enums/bankAccountProvider.enum';
import { DialogService } from 'src/app/services/dialog.service';
import { ConfirmDialogParams } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { LinkedBankAccountService } from '../../linked-bank-account.service';

const ANGULAR_MATERIAL = [MatIconModule, MatButtonModule, MatMenuModule];
const STANDALONE_COMPONENT = [ButtonsComponent];

@Component({
  selector: 'terra-external-bank-account-actions',
  standalone: true,
  imports: [CommonModule,
    ...ANGULAR_MATERIAL,
    ...STANDALONE_COMPONENT],
  templateUrl: './external-bank-account-actions.component.html',
  styleUrls: ['./external-bank-account-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalBankAccountActionsComponent implements OnInit {
  @Input() bankAccount: BankAccountTableRowDto;
  constructor(
    private bankAccountsMsService:BankAccountsMsService,
    private linkedBankAccountService: LinkedBankAccountService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {

  }
  
  editAccount(){
    const data = new EditAccountDetailsDialogContext();
    data.clientBankAccountId = this.bankAccount.id;
    data.nickname = this.bankAccount.accountNickname;
    data.bankName = this.bankAccount.bankName;
    data.accountNumber = this.bankAccount.accountNumber;
    data.accountType = this.bankAccount.accountType || AccountType.Primary;
    data.entityType = this.bankAccount.entityType;

    if (this.bankAccount.entityType?.toLowerCase() === 'business') {
      data.companyDetailsId = this.bankAccount.entityId;
    }
    else if (['fund', 'asset'].includes(this.bankAccount.entityType?.toLowerCase())) {
      data.holdingId = +this.bankAccount.entityId;
    }

    this.dialogService.customDialog<EditAccountDetailsDialogComponent>(EditAccountDetailsDialogComponent, data).afterClosed().pipe(
      take(1),
      filter(res => !!res),
      tap(_ => this.bankAccountsMsService.bankAccountRefresh())
    ).subscribe()
  }

  disconnectAccount(){
    const dialogParams = new ConfirmDialogParams('Disconnect Account', `<div class='flex flex-column gap-4'>
    <span>Note that disconnecting a bank will disable the balance visibility and other finance operation options.</span>
    <span>Are you sure you want to disconnect this account?</span>
    </div>`, 'Disconnect Account', 'Cancel', 'disconnect-account-dialog', null, null, 'primary', null, null, 'right', null, null, null, false, null, '#CA0005')
    this.dialogService.confirmDialog(dialogParams)
      .afterClosed().pipe(
        take(1),
        filter(res => !!res),
        switchMap(_ => this.linkedBankAccountService.disconnectLinkedBankAccounts(this.bankAccount.id)),
        tap(_ => this.bankAccountsMsService.bankAccountRefresh()))
      .subscribe();
  }
}
